module.exports = __webpack_public_path__ + "static/media/edan.854e904a.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Spill/static/edan.png
// module id = 191
// module chunks = 0